module.exports = __webpack_public_path__ + "img/cert_09.03e58575.jpg";